module.exports = __webpack_public_path__ + "img/cctel.ed431d25.png";